require('../profile.scss');

var profileValidator = require('../validation');
var helper = require('../profile-helper');

function init(firebase) {
    var signInDrawerSelector = '#sign-in-drawer';
    var signInDrawer = $(signInDrawerSelector);
    var signInForm = signInDrawer.find('#sign-in-form');
    var formErrorSelector = '#sign-in-form-error';
    var forgotPasswordEmailSelector = '#forgot-password-email';

    signInForm.on('submit', function(e) {
        e.preventDefault();

        var form = e.target;
        if (profileValidator.isFormValid(signInForm)) {
            return firebase.auth().signInWithEmailAndPassword(form.email.value, form.password.value).then(function(user) {
                helper.onSignIn(user);
            }).catch(function(error) {
                profileValidator.parseFirebaseError(error, formErrorSelector);
            });
        }
    });

    signInForm.on('blur', 'input', function(e) {
        var input = e.target;
        if (input.name === 'email') {
            $(forgotPasswordEmailSelector).val(input.value);
        }
        profileValidator.validateField(signInForm, input, formErrorSelector);
    });

    helper.on('signIn', function() {
        signInDrawer.modal('hide');
    });
}

module.exports = {
    init: init
};




//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/sign-in/sign-in-drawer.js
// module id = 80
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14